import React, {PropsWithChildren, useEffect, useRef} from "react"
import classNames from "classnames"
import Icon from "../Icon/Icon"
import {useClickAway} from "react-use"
import {useEsc} from "../../hooks/useEsc"
import {IcomoonIconName} from "../Icon/icons"

interface FloatingCardProps {
	title: string
	prefixIcon?: IcomoonIconName
	suffix?: JSX.Element
	onClose: () => void
	enableClickAway?: boolean
	blockBodyScroll?: boolean
	className?: string
}

export function FloatingCard(props: PropsWithChildren<FloatingCardProps>) {
	const {
		title,
		prefixIcon,
		suffix,
		onClose,
		enableClickAway = false,
		blockBodyScroll = false,
		className,
		children,
	} = props

	const ref = useRef<HTMLDivElement>(null)

	useEsc(onClose)

	if (enableClickAway) {
		useClickAway(ref, onClose)
	}

	useEffect(() => {
		if (blockBodyScroll) {
			document.body.classList.add("no-body-scroll")
			return () => {
				document.body.classList.remove("no-body-scroll")
			}
		}
	}, [blockBodyScroll])

	return (
		<div className={classNames("floating-card", className)}>
			<div className="floating-card-header" ref={ref}>
				<div className="floating-card-title">
					{prefixIcon && <Icon icon={prefixIcon} size={16} className="mr-2" />}
					<span>{title}</span>
					{suffix}
				</div>
				<div className="floating-card-close" onClick={onClose}>
					<Icon icon="delete-close-x" size={16} />
				</div>
			</div>
			<div className="floating-card-body">{children}</div>
		</div>
	)
}
